import appUtils from './app_utils'

require('intersection-observer')

let targets;
const inoutObserverOptions = {
 rootMargin: '-50% 0px -50% 0px',
 threshold: 0.0
};
const inoutObserverCallback = (entries, inoutObserver) => {
  // const scrollPos = appUtils.$window.scrollTop()
  entries.forEach(entry => {
    /*
    if (entry.isIntersecting) {
      console.log('Enter')
      return
    }
    */
    let eventName = ''
    //scrollPos > entry.boundingClientRect.top
    if (entry.boundingClientRect.top > 0 && entry.isIntersecting) {
      eventName = entry.target.getAttribute('data-iocallback-eventbelow')
    }
    if (entry.boundingClientRect.top < 0 && entry.isIntersecting) {
      eventName = entry.target.getAttribute('data-iocallback-eventabove')
    }
    if (entry.isIntersecting) {
      appUtils.triggerEvent('set-active-section', entry)
      entry.target.classList.add("in-view")
      entry.target.classList.add("in-view-once")
    } else {
      entry.target.classList.remove("in-view")
    }
    if (eventName) {
      appUtils.triggerEvent(eventName, entry)
    }
  })
}

// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/IntersectionObserver
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/observe
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/unobserve
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/disconnect
const inoutObserver = new IntersectionObserver(inoutObserverCallback, inoutObserverOptions);

const init = function() {
  targets = document.querySelectorAll("[data-iocallback]");
  if (targets.length) {
    targets.forEach(target => inoutObserver.observe(target));
  }
}

const destroy = function() {
  if (targets.length) {
    targets.forEach(target => inoutObserver.unobserve(target));
  }
}

export default {init, destroy}
